module.exports = __webpack_public_path__ + "static/media/main.b16d869c.png";